import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import HowItWorks from './HowItWorks';
import CreatorInfo from './CreatorInfo';
import StartTestButton from './StartTestButton';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <motion.div 
        className="hero-section"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h1>Termómetro Emocional</h1>
        <h2>Evalúa tu bienestar en solo 3 minutos</h2>
        
        <div className="hero-description">
          <p>Test gratuito y confidencial para personas que experimentan <span className="highlight">tristeza</span>, <span className="highlight">ansiedad</span>, <span className="highlight">estrés</span>, dificultades tras una <span className="highlight">ruptura</span>, problemas de <span className="highlight">autoestima</span> o <span className="highlight">insomnio</span>.</p>
          <p className="disclaimer">No es un diagnóstico clínico, sino una herramienta de reflexión personal.</p>
        </div>
        
        <motion.div 
          className="cta-button-container"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Link to="/area-selection" className="cta-button">
            Comenzar mi evaluación
          </Link>
        </motion.div>
      </motion.div>
      
      <HowItWorks />
      
      <CreatorInfo />
      
      {/* Botón añadido al final de la página */}
      <StartTestButton />
    </div>
  );
};

export default Home;
